import React from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Userid = (props) => {
  return (
    <Form.Group>    
      <Form.Group>
        <Row>
          <Col xs={6}>
            <Form.Label>
            <span className="not-required"></span>User Id
            </Form.Label>
          </Col>
          <Col xs={6}>
            <Form.Control
              onChange={(e) => {
                const { value } = e.target; // <-- moved outside asynchronous context to fix errors

                props.handleUserIdChange(value);
              }}
              type="string"
              placeholder="If you are a COP employee then please provide your User Id."
              maxLength="20"
            />
            <Form.Text className="text-muted">
              Only share if you are a COP employee.
            </Form.Text>
          </Col>
        </Row>
      </Form.Group>
    </Form.Group>
  );
};

export default Userid;
